export const EXPAND_SECTION = 'EXPAND_SECTION';
export const COLLAPSE_SECTION = 'COLLAPSE_SECTION';
export const TOGGLE_SECTION = 'TOGGLE_SECTION';
export const PUSH_SECTION = 'PUSH_SECTION';
